// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"cb45a31c","745":"c9a4acc6"}[chunkId] + ".chunk.js";
};